import ReducerRegistry from "../base/redux/ReducerRegistry";
const initialState = {
    fetched: false
};
const odontoconectaReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'odontoconecta/SET_DATA':
            return action.payload.odontoconecta;
        default:
            return state;
    }
};
ReducerRegistry.register('features/odontoconecta', odontoconectaReducer);
